import React from 'react';
import { useNavigate } from 'react-router-dom';
import { setMobileMenuOpen } from '../../../Store/Actions/navigationHeaderActions';
import { useDispatch } from 'react-redux';

interface NavigationListItemProps {
    menuItemText: string;
    icon: React.ReactNode;
    link?: string;
    click?: () => void;
    openDropdown: number | null;
    toggleDropdown: (value: number | null) => void;
    noPadding?: boolean;
}

export default function NavigationListItem({
    menuItemText,
    icon,
    link = '',
    click,
    openDropdown,
    toggleDropdown,
    noPadding = false,
}: NavigationListItemProps) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (
        <>
            {link !== '' ? (
                <>
                    <li
                        className={`m-0 flex items-center gap-3 group cursor-pointer ${noPadding ? 'py-0' : 'py-1'}`}
                        onClick={() => {
                            toggleDropdown(openDropdown);
                            dispatch(setMobileMenuOpen(false));
                            navigate(link);
                        }}
                    >
                        <span className="text-layout-textcolor group-hover:text-primary transtition-all duration-100">
                            {icon}
                        </span>
                        <p className="p-0 m-0 text-layout-textcolor group-hover:text-primary transtition-all duration-100 ">
                            {menuItemText}
                        </p>
                    </li>
                </>
            ) : (
                <>
                    <li
                        className={`m-0 flex items-center gap-3 group cursor-pointer ${noPadding ? 'py-0' : 'py-1'}`}
                        onClick={() => {
                            toggleDropdown(openDropdown);
                            dispatch(setMobileMenuOpen(false));
                            click && click();
                        }}
                    >
                        <span className="text-layout-textcolor group-hover:text-primary transtition-all duration-100">
                            {icon}
                        </span>
                        <p className="p-0 m-0 text-layout-textcolor group-hover:text-primary transtition-all duration-100 ">
                            {menuItemText}
                        </p>
                    </li>
                </>
            )}
        </>
    );
}
